<div class="npdc-title">
  @if (role(); as role) {
    <h1>Edit user role - {{ role.name }}</h1>
  } @else {
    <h1>New user role</h1>
  }

  <div class="npdc-title__actions">
    @if (form.pristine) {
      <a mat-flat-button type="button" routerLink="/role">Close</a>
    } @else {
      <a mat-button type="button" routerLink="/role">Close</a>
    }
  </div>
</div>

<mat-tab-group animationDuration="0ms" disablePagination="true">
  <mat-tab>
    <ng-template mat-tab-label><mat-icon>info</mat-icon>General </ng-template>
    <form id="form" [formGroup]="form" (ngSubmit)="save()">
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <input required matInput formControlName="name" />
        </mat-form-field>
      </p>

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Endpoints</mat-label>
          <textarea
            rows="3"
            required
            formControlName="endpoints"
            matInput
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="5"
          ></textarea>
          <mat-hint
            >Newline separated list of endpoints in “METHOD HOST PATH” format. Wildcard *
            substitutes UUIDs, e.g.
            {{
              'DELETE example.com /dataset/545caaab-7feb-4012-9291-7cc51d6ca81a/attachment/*'
            }}</mat-hint
          >
        </mat-form-field>
      </p>

      <p class="npdc-form-actions">
        <button mat-flat-button type="submit" [disabled]="form.pristine || form.invalid">
          Save
        </button>
        @if (role()) {
          <button mat-stroked-button type="button" (click)="delete()">Delete</button>
        }
      </p>
    </form>
  </mat-tab>

  <mat-tab [disabled]="!role()">
    <ng-template mat-tab-label>
      <mat-icon>group</mat-icon>
      Users
    </ng-template>

    <p>
      <button mat-flat-button (click)="addUser()">Add</button>
      @if (userList.selectedOptions.selected.length; as length) {
        <button mat-button (click)="removeUsers(userList.selectedOptions.selected)">Remove</button>
      }
    </p>

    <app-list [resource]="users">
      <mat-selection-list #userList>
        @if (!users.error()) {
          @for (user of users.value()?.items; track user.id) {
            <mat-list-option [value]="user.id" togglePosition="before">
              <span matListItemTitle>{{ user.email }}</span>
              <span matListItemLine>{{ user.accessLevel }}</span>
              <span matListItemLine>{{ user.status }}</span>
            </mat-list-option>
          }
        }
      </mat-selection-list>

      @if (!users.error()) {
        <mat-paginator
          showFirstLastButtons
          (page)="page.set($event.pageIndex)"
          [length]="users.value()?.count"
          [pageIndex]="page()"
          [pageSize]="pageSize()"
          [pageSizeOptions]="[10, 20, 50, 100]"
        >
        </mat-paginator>
      }
    </app-list>
  </mat-tab>
</mat-tab-group>
